type PolicySection = {
  title: string;
  body?: string[];
  bullets?: string[];
};

type PolicyPageLayoutProps = {
  eyebrow: string;
  title: string;
  sections: PolicySection[];
};

export const PolicyPageLayout = ({
  eyebrow,
  title,
  sections,
}: PolicyPageLayoutProps) => {
  return (
    <div className="bg-white">
      <section className="pt-36 pb-16 px-6 md:px-12 lg:px-24 bg-white">
        <div className="max-w-4xl mx-auto">
          <p className="text-primary text-xs font-semibold tracking-[0.35em] uppercase mb-4">
            {eyebrow}
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-neutral-900 mb-6">
            {title}
          </h1>
          <div className="w-20 h-1 bg-primary" />
        </div>
      </section>

      <section className="pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto space-y-12">
          {sections.map((section) => (
            <div
              key={section.title}
              className="pb-10 border-b border-neutral-200 last:border-b-0">
              <h2 className="font-serif text-2xl md:text-3xl text-neutral-900 mb-4">
                {section.title}
              </h2>
              {section.body?.map((paragraph, index) => (
                <p
                  key={`${section.title}-body-${index}`}
                  className="text-neutral-600 leading-relaxed mb-4 last:mb-0">
                  {paragraph}
                </p>
              ))}
              {section.bullets && (
                <ul className="mt-4 space-y-2 list-disc list-inside text-neutral-600">
                  {section.bullets.map((item) => (
                    <li key={`${section.title}-${item}`}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
